import React from 'react';
import { FaInstagram, FaFacebook } from 'react-icons/fa'; // Import icons

const Footer = () => {
    return (
        <footer className="footer">
            <p></p>
            <div className="social-icons">
                <a href="https://www.instagram.com/galperin_olga" target="_blank" rel="noopener noreferrer">
                    <FaInstagram size={24} />
                </a>
                <a href="https://www.facebook.com/profile.php?id=100004212422587" target="_blank" rel="noopener noreferrer">
                    <FaFacebook size={24} />
                </a>
            </div> 
        </footer>
    );
};

export default Footer;
